import { ListProps } from '@ui-system/interfaces-list';

const defaultProps: Partial<ListProps> = {};

export default defaultProps;
